import { useState, useEffect } from "react";
import { Loader2 } from "lucide-react";

const LOADING_MESSAGES = [
  "Analisando seu mercado...",
  "Aplicando conceitos de design...",
  "Refinando tipografia...",
  "Harmonizando sua paleta de cores...",
  "Renderizando em alta definição...",
  "Finalizando sua identidade visual..."
];

interface LoadingMessagesProps {
  intervalMs?: number;
  className?: string;
  showIcon?: boolean;
}

export const LoadingMessages = ({ 
  intervalMs = 2500, 
  className = "",
  showIcon = true
}: LoadingMessagesProps) => {
  const [messageIndex, setMessageIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setMessageIndex((prev) => (prev + 1) % LOADING_MESSAGES.length);
    }, intervalMs);
    return () => clearInterval(interval);
  }, [intervalMs]);

  return (
    <span className={`inline-flex items-center gap-2 text-sm sm:text-base max-w-[280px] sm:max-w-none ${className}`}>
      {showIcon && <Loader2 className="w-4 h-4 animate-spin flex-shrink-0" />}
      <span className="truncate">{LOADING_MESSAGES[messageIndex]}</span>
    </span>
  );
};
